(function () {
  'use strict';

  var A = window.DevidAssistantCommerceV5;
  if (!A || !A.form || !A.input || !A.messages) return;
  var c = A.copy;

  function syncIntent(intent) {
    A.state.intent = intent;
    A.state.request = intent.raw || '';
    A.state.category = intent.category || '';
    A.state.gender = intent.gender || '';
    A.state.fit = intent.fit || '';
  }

  function doReturn(text, show) {
    A.reset();
    if (show !== false) A.user(text);
    var message = A.assistant(c.returnTitle, c.returnText);
    var row = document.createElement('div');
    var link = document.createElement('a');
    row.className = 'devid-assistant-v2__cta-row';
    link.className = 'devid-assistant-v2__cta';
    link.href = A.accountUrl || A.shopRoot + 'account';
    link.textContent = c.account;
    row.appendChild(link);
    message.stack.appendChild(row);
    A.scroll();
  }

  function askProductCategory() {
    A.state.stage = 'category';
    A.ask(c.productTitle, c.category, c.categories, productCategory);
  }

  function askProductGender() {
    A.state.stage = 'gender';
    A.ask(c.productTitle, c.gender, c.genders, productGender);
  }

  function startProduct(text, show) {
    A.reset();
    A.state.flow = 'product';
    if (show !== false && text) A.user(text);
    var intent = A.intent(text || '');
    syncIntent(intent);
    if (!intent.category) askProductCategory();
    else if (!intent.gender) askProductGender();
    else runProduct();
  }

  function productCategory(value) {
    A.user(value);
    var intent = A.intent(value || '');
    syncIntent(intent);
    if (!intent.category) {
      askProductCategory();
      return;
    }
    if (!intent.gender) askProductGender();
    else runProduct();
  }

  function productGender(value) {
    A.user(value);
    var intent = A.intent(value || '', A.state.intent || {});
    syncIntent(intent);
    if (!intent.gender) {
      askProductGender();
      return;
    }
    runProduct();
  }

  async function runProduct() {
    A.state.busy = true;
    A.state.stage = 'searching';
    var loading = A.loading(c.loading);
    try {
      var intent = A.state.intent || A.intent(A.state.request || '', {
        category: A.state.category,
        gender: A.state.gender,
        fit: A.state.fit
      });
      var products = await A.fetchProducts(intent.category, intent.gender, intent.raw);
      var selected = A.selectMixedProducts(products, intent.raw, intent.gender, intent.category, intent.fit);
      selected = await A.attachDynamicPartnersV6(selected, intent);
      A.remove(loading);
      if (!selected.length) {
        A.assistant('', c.none);
        askProductCategory();
        return;
      }
      var message = A.assistant(c.results, c.resultText);
      A.productRail(message.stack, selected);
      A.state.stage = 'results';
      A.emit('assistant_product_grid_shown', {
        result_count: selected.length,
        gender: intent.gender,
        category: intent.category,
        subtype: intent.subtype || '',
        weight: intent.weight || '',
        vendors: selected.map(function (product) { return product.vendor || ''; })
      });
      A.scroll();
    } catch (error) {
      A.remove(loading);
      A.assistant('', c.none);
      askProductCategory();
    } finally {
      A.state.busy = false;
    }
  }

  function askLookItem() {
    A.state.stage = 'item';
    A.ask(c.lookTitle, c.lookItem, c.lookItems, lookItem);
  }

  function askLookGender() {
    A.state.stage = 'gender';
    A.ask('', c.gender, c.genders, lookGender);
  }

  function askLookFit() {
    A.state.stage = 'fit';
    A.ask('', c.fit, c.fits, lookFit);
  }

  function continueLook(intent) {
    syncIntent(intent);
    if (!intent.category) askLookItem();
    else if (!intent.gender) askLookGender();
    else if (!intent.fit) askLookFit();
    else runLook();
  }

  function startLook(text, show) {
    A.reset();
    A.state.flow = 'look';
    if (show !== false && text) A.user(text);
    var intent = A.intent(text || '');
    if (!intent.category) askLookItem();
    else continueLook(intent);
  }

  function lookItem(value) {
    A.user(value);
    continueLook(A.intent(value || ''));
  }

  function lookGender(value) {
    A.user(value);
    continueLook(A.intent(value || '', A.state.intent || {}));
  }

  function lookFit(value) {
    A.user(value);
    continueLook(A.intent(value || '', A.state.intent || {}));
  }

  async function runLook() {
    A.state.busy = true;
    A.state.stage = 'searching';
    var loading = A.loading(c.lookLoading);
    try {
      var intent = A.state.intent;
      var products = await A.fetchProducts(intent.category, intent.gender, intent.raw);
      var match = await A.findLookPairV6(products, intent);
      A.remove(loading);
      if (!match) {
        A.state.stage = 'item';
        A.ask('', c.noLook, [c.again], function () { askLookItem(); });
        return;
      }
      A.state.stage = 'results';
      A.renderPair(match, c.lookResult, c.lookText);
      A.emit('assistant_outfit_shown', {
        gender: intent.gender,
        category: intent.category,
        subtype: intent.subtype || '',
        fit: intent.fit || '',
        base_handle: match.handle || '',
        partner_handle: match.bundle_partner && match.bundle_partner.handle || '',
        pair_source: 'configured_or_dynamic'
      });
    } catch (error) {
      A.remove(loading);
      A.state.stage = 'item';
      A.ask('', c.noLook, [c.again], function () { askLookItem(); });
    } finally {
      A.state.busy = false;
    }
  }

  function activeText(text) {
    if (A.state.busy) return;
    if (A.state.flow === 'product') {
      if (A.state.stage === 'category') productCategory(text);
      else if (A.state.stage === 'gender') productGender(text);
      else startProduct(text, true);
      return;
    }
    if (A.state.flow === 'look') {
      if (A.state.stage === 'item' || A.state.stage === 'results') lookItem(text);
      else if (A.state.stage === 'gender') lookGender(text);
      else if (A.state.stage === 'fit') lookFit(text);
    }
  }

  A.root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-assistant-prompt]');
    if (!button || !A.root.contains(button)) return;
    var action = button.getAttribute('data-assistant-action') || '';
    var prompt = button.getAttribute('data-assistant-prompt') || button.textContent || '';
    if (action === 'order') {
      A.reset();
      return;
    }
    if (!/^(return|product|look)$/.test(action)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (action === 'return') doReturn(prompt, true);
    else if (action === 'product') startProduct(prompt, true);
    else startLook(prompt, true);
  }, true);

  A.form.addEventListener('submit', function (event) {
    var text = (A.input.value || '').trim().slice(0, 500);
    if (!text) return;
    var shouldHandle = Boolean(A.state.flow) || A.isReturn(text) || A.isLook(text) || A.isProduct(text);
    if (!shouldHandle) {
      A.reset();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    A.input.value = '';
    if (A.state.flow) activeText(text);
    else if (A.isReturn(text)) doReturn(text, true);
    else if (A.isLook(text)) startLook(text, true);
    else startProduct(text, true);
  }, true);

  if (A.resetButton) A.resetButton.addEventListener('click', A.reset, true);
})();
